export default "__VITE_ASSET__BNBeagtZ__"